import { Component, OnInit } from '@angular/core';

import { Chain } from '@dcsg-ngx-ecommerce/core';
import { ERROR_MESSAGES } from './site-down-message.constants';

@Component({
	selector: 'origin-site-down',
	templateUrl: './site-down.component.html',
	styleUrls: ['./site-down.component.scss']
})
export class SiteDownComponent implements OnInit {

	errorMessageConfig: any;

	constructor(private chain: Chain) {}

	ngOnInit() {
	  const chainValue = this.chain.chainMarketingIdentifierAbbr;
	  this.errorMessageConfig = ERROR_MESSAGES[chainValue] || ERROR_MESSAGES['dsg']; // default to dickssportinggoods if chainValue is not matched
	}
}
